import { useMemo } from 'react';
import { EngageMessageChannel } from 'types/domain';

interface UseSendTestMessageConfigOptions {
    body: string | null;
    subject: string | null;
    sender_id: number | null;
    channel: EngageMessageChannel;
}

const useSendTestMessageConfig = ({
    body,
    subject,
    sender_id,
    channel,
}: UseSendTestMessageConfigOptions) => {
    const isDisabled = useMemo(
        () => !body || (channel === 'email' && !subject) || !sender_id,
        [body, subject, sender_id, channel],
    );
    const disabledReasons = useMemo(() => {
        if (!isDisabled) return '';

        let missingItems: string[] = [];
        if (!sender_id) missingItems.push('sender');
        if (!body) missingItems.push('body');
        if (!subject && channel === 'email') missingItems.push('subject');

        let missingItemsLabel = '';
        if (missingItems.length > 2) {
            missingItemsLabel = missingItems
                .map((item, index) => {
                    return index + 1 >= missingItems.length ? `and ${item}` : item;
                })
                .join(', ');
        } else {
            missingItemsLabel = missingItems.join(' and ');
        }

        return missingItemsLabel;
    }, [isDisabled, body, subject, sender_id, channel]);

    const tooltipMessage = useMemo(() => {
        if (!disabledReasons) return '';
        return `Please provide a message ${disabledReasons} to enable sending a test.`;
    }, [disabledReasons]);

    return {
        isDisabled,
        disabledReasons,
        tooltipMessage,
    };
};

export { useSendTestMessageConfig };
